export const COLORS = {
	grey: '#767CA8',
	lightGrey: '#d9dade',
	greyClair: '#F2F3F7',
	blue: '#647FE8',
	vividSkyBlue: '#4d7fff',
	lightBlue: '#E4E7FF',
	offWhiteBlue: '#F9F9FF',
	skyBlue: '#93aaca',
	black: '#292D30',
	darkBlue: '#0F284B',
	brightBlue: '#5567ff0f',
	error: '#EF4444',
	flameRed: '#f04438',
	coralRed: '#F6635A',
	turquoise: '#40e0d0',
	mediumpurple: '#9370db',
	text: {
		preFilled: '#DEDEDE',
		placeholder: '#8D8D8D',
		filled: '#474554',
	},
	background: {
		primary: '#FFFFFF',
		secondary: '#F2F2F7',
		tertiary: '#FFFFFF',
		content: '#F5F5FA',
	},
	scroll: {
		primary: '#ccc',
	},
	warning: {
		primary: '#FF9D47',
	},
	success: {
		primary: '#32BA7C',
	},
};
